import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import classes from "../../style/Style.module.css";
import "../../style/Infoscreens.scss";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ROUTE_FATCA_CONFIRMATION,
  ROUTE_MOBILE_VERIFICATION,
  ROUTE_Purchase_One_Time,
  
  ROUTE_CUSTOMER_SUPPORT_SCREEN,
} from "../../Routes";
import axios from "../../libs/axiosConfig";
import Toast from "../../Components/ToastMsg/Toast";
import { selectPanNumber } from "../../Store/panNumberSlice";
import { useSelector } from "react-redux";
import { selectPhoneNumber } from "../../Store/MobileSlice";
import LogoutModal from "../../Components/LogoutModal";
import { selectIINNumber } from "../../Store/IINSlice";

const FATCAConfirmation = () => {
  const Navigate = useNavigate();
  const panNumber = useSelector(selectPanNumber);

  const [showModal, setShowModal] = useState(false);
  const storedToken = useSelector((state) => state.storedToken.accessToken);
  const phoneNumber = useSelector(selectPhoneNumber);
  const location = useLocation();
  const { IIN_Number } = location.state || {};
  console.log(IIN_Number, panNumber);
  const HandleBack = () => {
    setShowModal(true);
  };

  const handleLogoutConfirm = () => {
    Navigate(ROUTE_MOBILE_VERIFICATION);
  };
 const HandleSubmit = () => {
  console.log("Submit button clicked");
    const requestBody = {
      nseFatcaEnquiry: {
        iin: IIN_Number,
        pan: panNumber,
      },
    };

    axios
      .post(
        "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
        requestBody
      )
      .then((response) => {
        const { status ,fatca_reg} = response.data.body;
        console.log(response.data.body);
        if (status === "Success") {
          if (
            fatca_reg === "Y"
            // && fatca_verify_status === "Y"
          ) {
            Navigate(ROUTE_Purchase_One_Time);
          } else if (fatca_reg !== "Y") {
            // const response = axios.get(
            //   "https://partnerapp.ambrela.money/api/GetCustomerKycDetails",
            //   {
            //     headers: {
            //       Authorization: `Bearer ${storedToken}`,
            //       // RefreshToken: refreshToken,
            //     },
            //   }
            // );

            const GetAPIData = response.data.body;
            const fullname = GetAPIData.panDetails.inv_name;
            if (
              response.data.statusCode === 200 &&
              response.data.status === true
            ) {
              const FatcaApiResponse = axios.post(
                "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                {
                  nseFatca: {
                    mobile_no: phoneNumber,
                    pan: panNumber,
                    iin: IIN_Number,
                    investor_name: fullname,
                    app_income_code: GetAPIData.nseIncomeCode,
                    occ_code: GetAPIData.nseOccupationCode,
                    dob: GetAPIData.dob,
                    log_name: GetAPIData.emailId,
                    country_of_birth: GetAPIData.nseCountryCodeOfBirth,
                    place_birth: GetAPIData.placeOfBirth,
                  },
                },
                {
                  headers: {
                    Authorization: `Bearer ${storedToken}`,
                    // RefreshToken: refreshToken,
                  },
                }
              );

              if (
                FatcaApiResponse.data.status === "true" &&
                FatcaApiResponse.data.statusCode === 200 &&
                FatcaApiResponse.data.body.status === "Success"
              ) {
                console.log("in nseIIN api 3rd condition work");

                const recheckresponse = axios.post(
                  "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                  requestBody
                );
                const { status ,fatca_reg,fatca_verify_status} = response.data.body;
                console.log(response.data.body);

                if (status === "Success") {
                  if (
                    fatca_reg === "Y"
                    // && fatca_verify_status === "Y"
                  ) {
                    Navigate(ROUTE_Purchase_One_Time, {
                      state: {
                        IIN_Number: IIN_Number,
                      },
                    });
                  } 
                  else if (fatca_reg === "Y"
                                // && fatca_verify_status !== "Y"
                                ) 
                                
                                {
                                  const FatcaActivation =  axios.post(
                                    "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                                    {
                                      FatcaActivation: {
                                        
                                        pan: panNumber,
                                        
                                      },
                                    },
                                    {
                                      headers: {
                                        Authorization: `Bearer ${storedToken}`,
                                        // RefreshToken: refreshToken,
                                      },
                                    }
                                  );

                                  const recheckresponse =  axios.post(
                                    "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                                    requestBody
                                  );
                                  const { nseFatcaEnquiryData } =
                                    recheckresponse.data;
                                  const { status, nseFatcaEnquiry } =
                                    nseFatcaEnquiryData;

                                    if (status === "Success") {
                                      if (
                                        nseFatcaEnquiry.fatca_reg === "Y"
                                        // && nseFatcaEnquiry.fatca_verify_status === "Y"
                                      ) {
                                        Navigate(ROUTE_FATCA_CONFIRMATION)
                                    }
                                  }

                                }
                } else {
                  if (status !== "Success") {
                    Toast.error(recheckresponse.data.errorMessage || "Failed");
                    console.log("1");
                  }
                }

                // Navigate(ROUTE_Purchase_One_Time);
              } else {
                Toast.error("fetching FATCA details failed");
                console.log("2");
                Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                  state: {
                    reason:
                      "Your FATCA Failed",
                  },
                });              }
            } else {
              Toast.error(response.data.errorMessage);
            }
          }
          // else if (fatca_reg === "Y"

          // // && fatca_verify_status !== "Y"
          //   ) {
          //   Navigate(ROUTE_FATCA_CONFIRMATION)
          // }
        } else {
          if (status !== "Success") {
            Toast.error(response.data.errorMessage || "Failed");
          }
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
  return (
    <div className="Fatca_Confirmation_Main_Container">
      <div className="Fatca_Confirmation_Header">
        <ArrowBackIosIcon className="Back_btn" onClick={HandleBack} />
      </div>
      <div className="BlankText_Screen_Container">
        <p className="Input_Heading_text">
          Please click on the FATCA Confirmation Link shared by NSE with you via
          SMS and/or Email.
        </p>
        <p className="Input_Heading_text2">
          Waiting for FATCA confirmation from your side...
        </p>
        <button className="Submit_button" onClick={HandleSubmit}>
          Proceed
        </button>
      </div>
      <ToastContainer />
      <LogoutModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleLogoutConfirm}
      />
      ;
    </div>
  );
};

export default FATCAConfirmation;
